var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TreeSelect',{attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"data":_vm.data,"clearable":_vm.clearable,"append-to-body":_vm.appendToBody,"inline":_vm.inline,"multiple":_vm.multiple,"flat":_vm.multiple},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }